import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { StoreType } from "../../../../../../../redux/store/store";
import CustomDateInput from "../../../../../../../Components/CustomInputs/CustomDateInput";
import { updateFirstStepDynamicFields } from "../../../../../../../redux/reducers/claimReducer";
import {
   addErrorMessage,
   handleShowErrorMessage,
   removeErrorMessage,
   resetClaimFieldErrors,
} from "../../../../../../../redux/reducers/claimFieldErrorsReducer";
import { shouldRenderSpecField } from "../../../../../../../redux/reducers/visibilityMatrixesReducer";
import useFetch from "../../../../../../../CustomHooks/useFetch";
import { useScrollToTopErrorInput } from "../../../../../../../CustomHooks/useScrollToTopErrorInput";

const PermConsequencesDateOfClaimFromField: React.FC = () => {
   const dispatch = useDispatch();

   const DateOfClaimFromValue = useSelector(
      (state: StoreType) =>
         state.claimState.injuryDescriptionModelBase.injuryDescriptionModel.find(
            (model) => model.typeOfClaimEnum === 7
         )?.dateOfClaimFrom
   );
   const visibilityMatrixes = useSelector(
      (state: StoreType) => state.visibilityMatrixesState
   );

   const claimFieldErrorsMessages = useSelector(
      (state: StoreType) => state.claimFieldErrorsState
   );

   const token = useSelector((state: StoreType) => state.tokenState.token);
   const { personalId } = useSelector(
      (state: StoreType) => state.claimState.clientIdentification
   );

  //  const {
  //     sendRequest: sendRequestValidateDate,
  //     data: dataValidateDate,
  //     error: errorValidateDate,
  //     resetFetch: resetFetchValidateDate,
  //     fetchFired: fetchFiredValidateDate,
  //  } = useFetch();

  //  const callValidateDate = (date: string) => {
  //     sendRequestValidateDate({
  //        method: "POST",
  //        url:
  //           process.env.REACT_APP_BaseURL! +
  //           process.env.REACT_APP_ValidateDateForClaimType!,
  //        headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //        },
  //        data: {
  //           personId: personalId,
  //           injuryDateValue: date,
  //           typeOfClaimEnum: 7,
  //        },
  //     });
  //  };

  //  useEffect(() => {
  //     if (dataValidateDate === false) {
  //        dispatch(
  //           addErrorMessage({
  //              propertyId: "permconsequences.DateOfClaimFrom",
  //              message: "Pojištění nebylo aktivní v uvedeném datu",
  //           })
  //        );
  //     } else {
  //        dispatch(removeErrorMessage("permconsequences.DateOfClaimFrom"));
  //     }
  //  }, [fetchFiredValidateDate]);
   const ref = React.useRef<HTMLDivElement>(null);
   useScrollToTopErrorInput(ref, "permconsequences.DateOfClaimFrom");
   return (
      <CustomDateInput
         labelText="Kdy k úrazu došlo"
         name="DateOfClaimFrom"
         value={DateOfClaimFromValue || undefined}
         onChange={(val: string | null) => {
            dispatch(
               updateFirstStepDynamicFields({
                  value: val,
                  field: "dateOfClaimFrom",
                  typeOfClaimEnum: 7,
               })
            );
         }}
         validationText={handleShowErrorMessage(
            "permconsequences.DateOfClaimFrom",
            claimFieldErrorsMessages
         )}
         dependencyValue={
            shouldRenderSpecField(
               "permconsequences",
               "DateOfClaimFrom",
               visibilityMatrixes
            ) || true
         }
         inputRef={ref}
      />
   );
};

export default PermConsequencesDateOfClaimFromField;
